// Services
import ContactUsService from '@/app/services/main/contact-us/contact-us-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins';

export default {
    name: 'ContactUs',
    mixins: [ toastMessageMixins, userMixins ],
    data() {
        return {
            name: '',
            email: '',
            content: '',
			isAgreeTNC: false,
            isAPILoading: false
        }
    },
    computed: {
        validationRules() {
			let fields = {
                content: {},
                email: {},
                // isAgreeTNC: {}
			};

            fields = vuelidateUtil.setRequiredValidation(fields, 'content');
            fields = vuelidateUtil.setRequiredValidation(fields, 'email');
			fields = vuelidateUtil.setEmailValidation(fields, 'email');
			// fields = vuelidateUtil.setChecked(fields, 'isAgreeTNC');
            
			return fields;
		},
        isNativeApp() {
			return this.$store.getters.getIsNativeApp;
		},
        charactersLeft() {
            let char = this.content.length,
                limit = 500;
    
            return `${(limit - char)} / ${limit}`;
        }
    },
    watch: {},
    created() {},
    mounted() {
        this.$nextTick(() => {
            this.setUserDetails();
        });
    },
    methods: {
        setUserDetails() {
            const { firstName, lastName, emailAddress, id } = this.getUserDetails();

            if (id) {
                this.name = `${firstName} ${lastName}`;
                this.email = emailAddress;
            }
        },
        postContactUs() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const contactUsDetails = {
                name: this.name,
                email: this.email,
                content: this.content
            };

            this.isAPILoading = true;
            ContactUsService.postContactUs(contactUsDetails)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                        this.showCustomSuccessToast(null, 'Your inquiry has been sent!');
                        this.resetForm();
                    } else {
                        this.showAPIErrorToast('Unable to send inquiry.', res);
                    }
                })
                .catch(() => {
					this.showGenericErrorToast();
				})
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        resetForm() {
            this.name = '';
            this.email = '';
            this.content = '';
			this.isAgreeTNC = false;
            this.$v.$reset();
        },
        contactUsEmail(){
			window.location.href = 'mailto:services@lovemydogclub.com.au';
		},
        contactUsPhone() {
			window.location.href='tel:1300 307039'
        }
    },
	validations() {
		return this.validationRules;
	}
}